import React, { useMemo, useState } from "react";
import { Settings, X } from "lucide-react";
import { useVisualEngine } from "../visual-engine/VisualEngineProvider";
import "./ThemeSwitcher.css";

const DEV_VISIBLE = process.env.NODE_ENV !== "production";

const SWITCHER_THEMES = [
  { id: "molten", label: "Molten" },
  { id: "executive-commercial", label: "Executive Commercial" },
  { id: "remembrance", label: "Remembrance" },
  { id: "electrician", label: "Electrician" },
  { id: "growth", label: "Growth" },
];

export function ThemeSwitcher() {
  const { themeId, setThemeId } = useVisualEngine();
  const [open, setOpen] = useState(false);

  const activeTheme = useMemo(
    () => SWITCHER_THEMES.find((theme) => theme.id === themeId)?.label || themeId,
    [themeId]
  );

  if (!DEV_VISIBLE) {
    return null;
  }

  return (
    <div className="tl-dev-theme-switcher" data-testid="theme-switcher-dev-panel">
      {open ? (
        <div className="tl-dev-theme-popover" data-testid="theme-switcher-popover">
          <div className="tl-dev-theme-header">
            <span data-testid="theme-switcher-active-theme">{activeTheme}</span>
            <button
              type="button"
              className="tl-dev-theme-close"
              onClick={() => setOpen(false)}
              data-testid="theme-switcher-close"
              aria-label="Close theme switcher"
            >
              <X size={14} />
            </button>
          </div>

          <div className="tl-dev-theme-grid">
            {SWITCHER_THEMES.map((theme) => (
              <button
                key={theme.id}
                type="button"
                className={`tl-dev-theme-option ${theme.id === themeId ? "active" : ""}`}
                onClick={() => {
                  setThemeId(theme.id);
                  setOpen(false);
                }}
                data-testid={`theme-switch-option-${theme.id}`}
              >
                {theme.label}
              </button>
            ))}
          </div>
        </div>
      ) : (
        <button
          type="button"
          className="tl-dev-theme-trigger"
          onClick={() => setOpen(true)}
          data-testid="theme-switcher-open"
          aria-label="Open theme switcher"
        >
          <Settings size={16} />
        </button>
      )}
    </div>
  );
}

export default ThemeSwitcher;
